import { StringUtils, engineComponent } from "neo-common";
import { Style } from "./Style";
import { ComponentTypes } from "../../ComponentTypes";
import { AnimationStyleAttributes } from "../../ComponentAttributes";
import { CustomUtils } from "../../../Utils/CustomUtils";

/**
 * The animation style is used for defined behaviour animation from sprite sheet.
 * Example:
 *   <AnimationStyle Class="AnimationStyle" Animation="[libraryID]" StartFrame="0" EndFrame="0" Loop="false" Stop="false" />
 * @class AnimationStyle
 * @extends Style
 */
@engineComponent(ComponentTypes.Style)
export class AnimationStyle extends Style {
    // store only name of animation in style
    // element will create new instnce of animation not style
    animation: string;

    frames: Array<string>;

    // settings for animation
    startFrame: number;
    endFrame: number;
    speed: number;
    loop: boolean;
    stop: boolean;
    alpha: number;
    tint: number;
    blendMode: number;
    reverse: boolean;

    // for InsideAnimationElement
    node: Element;

    constructor() {
        super();

        // set default values
        this.animation = "";
        this.frames = null;
        this.startFrame = 0;
        this.speed = 1;
        this.loop = false;
        this.stop = false;
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);

        /**
         * Store node for InsideAnimationElement
         *
         * todo Toto sa pouziva?
         * @type {Element}
         */
        this.node = node;

        if (node.hasAttribute(AnimationStyleAttributes.ANIMATION)) {
            this.animation = node.getAttribute(AnimationStyleAttributes.ANIMATION);
        }

        if (node.hasAttribute(AnimationStyleAttributes.FRAMES)) {
            this.frames = node.getAttribute(AnimationStyleAttributes.FRAMES).split(";");
        }

        if (node.hasAttribute(AnimationStyleAttributes.START_FRAME)) {
            this.startFrame = parseInt(node.getAttribute(AnimationStyleAttributes.START_FRAME));
        }

        if (node.hasAttribute(AnimationStyleAttributes.END_FRAME)) {
            this.endFrame = parseInt(node.getAttribute(AnimationStyleAttributes.END_FRAME));
        }

        if (node.hasAttribute(AnimationStyleAttributes.LOOP)) {
            this.loop = StringUtils.parseBoolean(node.getAttribute(AnimationStyleAttributes.LOOP));
        }

        if (node.hasAttribute(AnimationStyleAttributes.STOP)) {
            this.stop = StringUtils.parseBoolean(node.getAttribute(AnimationStyleAttributes.STOP));
        }

        if (node.hasAttribute(AnimationStyleAttributes.SPEED)) {
            this.speed = parseFloat(node.getAttribute(AnimationStyleAttributes.SPEED));
        }

        if (node.hasAttribute(AnimationStyleAttributes.ALPHA)) {
            this.alpha = parseFloat(node.getAttribute(AnimationStyleAttributes.ALPHA));
        }

        if (node.hasAttribute(AnimationStyleAttributes.TINT)) {
            this.tint = parseInt(node.getAttribute(AnimationStyleAttributes.TINT), 16);
        }

        if (node.hasAttribute(AnimationStyleAttributes.BLEND_MODE)) {
            this.blendMode = CustomUtils.getBlendMode(parseInt(node.getAttribute(AnimationStyleAttributes.BLEND_MODE)));
        }
        if (node.hasAttribute(AnimationStyleAttributes.REVERSE)) {
            this.reverse = StringUtils.parseBoolean(node.getAttribute(AnimationStyleAttributes.REVERSE));
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/AnimationStyle.ts
 **/